
function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}

//t = current time
//b = start value
//c = change in value
//d = duration
Math.easeInOutQuad = function (t, b, c, d) {
    t /= d/2;
    if (t < 1) return c/2*t*t + b;
    t--;
    return -c/2 * (t*(t-2) - 1) + b;
};

function scrollToHorizontally(element, to, duration) {
    //element.scrollLeft = to;
    //return;

    let start = element.scrollLeft,
        change = to - start,
        currentTime = 0,
        increment = 10;

    let animateScroll = function(){
        currentTime += increment;
        let val = Math.easeInOutQuad(currentTime, start, change, duration);
        element.scrollLeft = val;
        if(currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };
    animateScroll();
}

function setItemsSize() {
    let el = document.querySelector(".slider-wrap");
    let itemsEl = document.querySelector(".container-slider-items");
    let width = itemsEl.clientWidth;

    let items = itemsEl.querySelectorAll(".container-slider-item");
    for(let i = 0; i < items.length; i++) {
        items[i].style.width = width + "px";
    }

    el.dataset.itemSize = width;

    //reset position
    if(el.dataset.position && parseInt(el.dataset.position) > 0) {
        moveToPosition(el, parseInt(el.dataset.position));
    }
}

const step = 1;

function initSlider() {
    const el = document.querySelector(".slider-wrap");
    const itemsEl = el.querySelector(".container-slider-items");

    setItemsSize();
    el.style.opacity = 1;

    el.dataset.position = "1";
    //el.dataset.scrolled = "0";

    let leftArrowEl = el.querySelector(".slider-arrow-left");
    let rightArrowEl = el.querySelector(".slider-arrow-right");

    leftArrowEl.addEventListener("click", function() {
        moveLeft(el);
    });

    rightArrowEl.addEventListener("click", function() {
        moveRight(el);
    });

    //Swipe
    let touchstartX = 0
    let touchendX = 0
    let doMove = isTouchDevice()

    function handleGesture() {
        if (touchendX < touchstartX) moveRight(el)
        if (touchendX > touchstartX) moveLeft(el)
    }

    //touch section
    itemsEl.addEventListener('touchstart', e => {
        touchstartX = e.changedTouches[0].screenX;
    })

    itemsEl.addEventListener('touchmove', e => {
        touchendX = e.changedTouches[0].screenX;

        if(doMove) {
            handleGesture()
            doMove = false

            setTimeout(function() {
                doMove = true;
            }, 200);
        }
    })

    itemsEl.addEventListener('touchend', e => {
        doMove = true;
    })
    //touch section end

    let navItems = el.querySelectorAll(".container-slider-navigation li");
    for(let i = 0; i < navItems.length; i++) {
        navItems[i].addEventListener("click", function() {
            moveToPosition(el, i + 1);
        });
    }
}

function moveLeft(sliderEl) {
    let currentPosition = parseInt(sliderEl.dataset.position);
    let newPosition = currentPosition - step;

    if(newPosition < 1) {
        newPosition = 1;
    }

    moveToPosition(sliderEl, newPosition);
}

function moveRight(sliderEl) {
    let itemsCount = sliderEl.querySelectorAll(".container-slider-item").length;
    let currentPosition = parseInt(sliderEl.dataset.position);
    let newPosition = currentPosition + step;

    if(currentPosition === itemsCount) {
        newPosition = 1;
    }

    if(newPosition > itemsCount) {
        newPosition = itemsCount;
    }

    moveToPosition(sliderEl, newPosition);
}

function moveToPosition(sliderEl, newPosition) {
    const speed = 250;

    sliderEl.dataset.position = newPosition;

    let slides = sliderEl.querySelector(".container-slider-items");
    let items = slides.querySelectorAll(".container-slider-item");
    let target = items[newPosition - 1];

    let navItem = document.getElementById("container-slider-navigation-" + target.dataset.id);

    if(navItem) {
        let navItems = sliderEl.querySelectorAll(".container-slider-navigation li");
        for(let i = 0; i < navItems.length; i++) {
            navItems[i].classList.remove("active");
        }

        navItem.classList.add("active");

        let navEl = sliderEl.querySelector(".container-slider-navigation");
        console.log(navEl, navItem.offsetLeft)
        // 100 is css width of the list item
        // position navItem in the middle of visible scrolling area
        scrollToHorizontally(navEl, navItem.offsetLeft - (navEl.clientWidth / 2) + 50, speed);
        //scrollToHorizontally(navEl, (newPosition - 1) * 100, speed);
    }

    if(slides) {
        //let scrolled = parseInt(sliderEl.dataset.scrolled);
        //let currentScrollPosition = slides.scrollLeft;x

        //return to beginning
        /*
        if(scrolled === currentScrollPosition && scrolled !== 0) {
            console.log("return to beginning");
            scrollToHorizontally(slides, 0, speed);
            sliderEl.dataset.scrolled = 0;
            sliderEl.dataset.position = 1;
            return;
        }*/

        let targetOffset;
        //round targetOffset to nearest stepSize
        let stepSize = parseInt(sliderEl.dataset.itemSize);
        if(stepSize){
            targetOffset = (newPosition - 1) * stepSize;
        } else {

            targetOffset = target.offsetLeft;
        }

        scrollToHorizontally(slides, targetOffset, speed);
        //sliderEl.dataset.scrolled = slides.scrollLeft;
    }
}

initSlider();

let resizeId;
window.addEventListener('resize', function () {
    clearTimeout(resizeId);
    resizeId = setTimeout(doneResizing, 10);
});

function doneResizing() {
    setItemsSize();
}

